import { render } from "./allocation-percentile.html?vue&type=template&id=11247c0c&scoped=true&ts=true&external"
import script from "./allocation-percentile.ts?vue&type=script&lang=ts&external"
export * from "./allocation-percentile.ts?vue&type=script&lang=ts&external"

import "./allocation-percentile.scss?vue&type=style&index=0&id=11247c0c&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11247c0c"]])

export default __exports__